import React from "react";
import { EnvironmentContext } from "../themes/environment";

export default class extends React.Component {
  render() {
    return (
      <div className="hivewatchbanner">
        <EnvironmentContext.Consumer>
          {({ logo }) => <img id="hivewatchlogo" src={logo} alt="HiveWatch" />}
        </EnvironmentContext.Consumer>
      </div>
    );
  }
}
